import { Component, computed, inject, input, output, signal } from '@angular/core';
import { Profile } from '../../models/profile';
import { NavService } from '../../services/nav.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-header-nav',
    imports: [],
    templateUrl: './header-nav.component.html',
    styleUrl: './header-nav.component.scss'
})
export class HeaderNavComponent {
  navService = inject(NavService);
  #userService = inject(UserService);

  profile = input<Profile | null>(null);

  mobileMenuExpanded = signal<boolean>(false);

  logoutClicked = output<void>();

  hasAccess = computed<boolean>(() => this.#userService.hasAccess())

  toggleMenu(): void {
    this.navService.toggle();
  }
}
